export { default } from './GlobalStyles';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/GlobalStyles/index.js
// module id = 272
// module chunks = 22